import React from 'react';

export const OffLayoutArea: React.FC = () => null;
